import { Component, OnInit } from '@angular/core';
import {ProfilService} from "../../services/mon-profil/profil.service";
import { ConfigurationService } from 'src/app/services/configuration.service';
import {CookieService} from "ngx-cookie-service";
import {TrustbuilderUtils} from "../../utils/trustbuilder-utils";
import { AuthentificationService } from 'src/app/services/auth/authentification.service';

@Component({
  selector: 'app-mon-profil',
  templateUrl: './mon-profil.component.html',
  styleUrls: ['./mon-profil.component.scss']
})
export class MonProfilComponent implements OnInit {

  constructor(private readonly authentificationService: AuthentificationService, 
    protected profilService :ProfilService, private readonly configurationService: ConfigurationService, 
    private cookieService: CookieService, private trustbuilderUtils : TrustbuilderUtils) {
    const username = JSON.parse(this.cookieService.get("access"))?.username
    this.login_mfa = this.trustbuilderUtils.aliasOf(username);
  }
  configuration=this.configurationService.get().mon_profil;
  config_global=this.configurationService.get();
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);
  login_mfa: string = "";
  isImpersonation: boolean = false;

  ngOnInit(): void {
    this.isImpersonation = this.authentificationService.isImpersonating();
  }

  handleUpdateFullName($event: any): void {
    const fullName = $event.userEntrepriseResponse?.prenom + " " + $event.userEntrepriseResponse?.nom ;
    this.profilService.updateFullName(fullName);
  }

  globalLogout() {
    this.authentificationService.httpLogout().subscribe();
    this.authentificationService.clearAccessStorage();
  }
}
